var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99997 12H5.25C5.46248 12 5.6406 12.0719 5.78435 12.2157C5.9281 12.3595 5.99997 12.5377 5.99997 12.7503C5.99997 12.9629 5.9281 13.141 5.78435 13.2846C5.6406 13.4282 5.46248 13.5 5.25 13.5H1.40385C1.14777 13.5 0.933108 13.4133 0.759875 13.2401C0.586625 13.0668 0.5 12.8522 0.5 12.5961V8.74995C0.5 8.53747 0.571908 8.35935 0.715725 8.2156C0.859542 8.07185 1.03774 7.99998 1.25033 7.99998C1.46293 7.99998 1.64102 8.07185 1.7846 8.2156C1.92818 8.35935 1.99997 8.53747 1.99997 8.74995V12ZM12 1.99998H8.74995C8.53747 1.99998 8.35935 1.92807 8.2156 1.78425C8.07185 1.64045 7.99997 1.46225 7.99997 1.24965C7.99997 1.03707 8.07185 0.858984 8.2156 0.715401C8.35935 0.571801 8.53747 0.5 8.74995 0.5H12.5961C12.8522 0.5 13.0668 0.586626 13.2401 0.759876C13.4133 0.933109 13.5 1.14777 13.5 1.40385V5.25C13.5 5.46248 13.428 5.6406 13.2842 5.78435C13.1404 5.9281 12.9622 5.99998 12.7496 5.99998C12.537 5.99998 12.3589 5.9281 12.2154 5.78435C12.0718 5.6406 12 5.46248 12 5.25V1.99998Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandContent);
export default __webpack_public_path__ + "static/media/expand_content.a0b027d2f75120c84f98df4bee0d65aa.svg";
export { ForwardRef as ReactComponent };